import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Moment from "moment/moment";
import {Paper} from "@mui/material";
import React from "react";
import {useTheme} from "@mui/material/styles";
import ValidatedTextField from "../Inputs/ValidatedTextField";
import {alphaNumericValidator} from "../../Helpers/ValidationHelpers";
import CategoriesAutocomplete from "./Inputs/CategoriesAutocomplete";

const ProductDetailsView = ({
                                product,
                                edit, 
                                setActiveForm,
                                isSubmitting,
                                formValid
                            }) => {
    const theme = useTheme();
    
    return (
        <Paper className="paper-rounded-edges">
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" className="detail-header-banner">Product</Typography>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Type</Typography>
                        <Typography>{product.productType}</Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Created At</Typography>
                        <Typography>{Moment(product.createdAt).format('D MMM YYYY, h:mma')}</Typography>
                    </Box>
                </Grid>
                <Grid size={{ xs: 12}}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold', mr: 2}}>Description</Typography>
                        {!edit &&
                            <Typography sx={{textAlign: 'right'}}>{product.description}</Typography>
                        }
                        {edit &&
                            <ValidatedTextField
                                id={'description'}
                                label={null}
                                validator={alphaNumericValidator}
                                onChange={isValid => (formValid.current.description = isValid)}
                                setActiveForm={setActiveForm}
                                isSubmitting={isSubmitting}
                                initialValue={product.description}
                                fieldPath={['description']}
                                infoAdornment={null}
                                size={"small"}
                                removeHelperTextPadding={true}
                            />
                        }
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Code</Typography>
                        {!edit && 
                            <Typography>{product.businessCode}</Typography>
                        }
                        {edit &&
                            <ValidatedTextField
                                id={'businessCode'}
                                label={null}
                                validator={alphaNumericValidator}
                                onChange={isValid => (formValid.current.businessCode = isValid)}
                                setActiveForm={setActiveForm}
                                isSubmitting={isSubmitting}
                                initialValue={product.businessCode}
                                fieldPath={['businessCode']}
                                infoAdornment={null}
                                size={"small"}
                                removeHelperTextPadding={true}
                            />
                        }
                        
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '10px',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Assembly File</Typography>
                        {!edit &&
                            <Typography>{product.sourceFileName ?? "Not supplied"}</Typography>
                        }
                        {edit &&
                            <ValidatedTextField
                                id={'sourceFileName'}
                                label={null}
                                validator={alphaNumericValidator}
                                onChange={isValid => (formValid.current.sourceFileName = isValid)}
                                setActiveForm={setActiveForm}
                                isSubmitting={isSubmitting}
                                initialValue={product.sourceFileName ?? ""}
                                fieldPath={['sourceFileName']}
                                infoAdornment={null}
                                size={"small"}
                                removeHelperTextPadding={true}
                            />
                        }
                    </Box>
                </Grid>
                {product.productType === 'Item' && <Grid size={{ xs: 12 }}>
                    <Box
                        sx={{
                            display:'flex',
                            justifyContent: 'space-between',
                            padding: '10px',
                            alignItems: 'center',
                            borderBottom: `1px solid ${theme.palette.divider}`
                        }}
                    >
                        <Typography sx={{ fontWeight: 'bold'}}>Categories</Typography>
                        {!edit &&
                            <Typography>
                                {product.categories.map((category) => (
                                    category.name
                                )).join(', ')}
                            </Typography>
                        }
                        {edit &&
                            <CategoriesAutocomplete 
                                initialValue={product.categories}
                                setActiveForm={setActiveForm}
                                createNewOptionsAllowed
                            />
                        }
                    </Box>
                </Grid>
                }
            </Grid>
        </Paper>
    )
}

export default ProductDetailsView;